import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';

import { pricingSyncResultSchema } from '../schemas/pricingSchemas';
import { pricingKeys } from './pricingKeys';

// "Refresh from Console" — pulls the latest Studio prices for all tenants and
// re-reads the grid on success.
export function useSyncPricing() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const raw = await apiClient.post('api/v1/admin/pricing/sync').json();
      return pricingSyncResultSchema.parse(raw);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: pricingKeys.all });
      // Console prices also feed the workflow builder's API catalogue (per-tenant
      // price overlay), so refresh those queries too — otherwise an open builder
      // keeps showing the pre-sync price until a full page reload.
      void queryClient.invalidateQueries({
        predicate: (q) => q.queryKey[0] === 'workflows' && q.queryKey.includes('catalogue'),
      });
    },
  });
}
